module.exports = __webpack_public_path__ + "img/Wp_2085.5e5e398b.png";